import { useInView } from 'react-intersection-observer';
import React from 'react';
import styled from 'styled-components';
import SectionTitle from '../../Components/SectionTitle';
import FadeInSection from '../../Components/FadeInSection';
import importAllImages from '../../utils/imageImporter';

const AboutContainer = styled.section`
  padding-top: 60px;
  padding-left: 80px;
  padding-right: 80px;

  @media (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const AboutContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 80px;
  gap: 120px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
    margin-top: 50px;
  }
`;

const AboutText = styled.p`
  max-width: 550px;

  margin: 0;

  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 1.8;

  color: #333333;
  text-align: left;

  @media (max-width: 768px) {
    text-align: justify;
  }
`;

const PhotoProfile = styled.img`
  width: 400px;
  height: 400px;

  border-radius: 50%;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 220px;
    height: 220px;
  }
`;

function AboutMe() {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.7,
    });

    const images = importAllImages();

    return (
        <AboutContainer>
            <div ref={ref}>
                <SectionTitle $animate={inView}>
                    About Me
                </SectionTitle>
            </div>

            <AboutContent>

                <FadeInSection>
                    <AboutText>
                        I am a developer passionate about creating beautiful,
                        functional, and intuitive digital experiences. I am
                        currently improving my web development skills, exploring
                        technologies such as React, JavaScript, and CSS.
                        <br /><br />
                        I enjoy transforming ideas into responsive and
                        well-structured interfaces, always looking for
                        opportunities to learn new tools and improve my
                        programming practices. My goal is to create projects that
                        combine design, performance, and a great user experience.
                    </AboutText>
                </FadeInSection>

                <FadeInSection delay="0.3s">
                    <PhotoProfile
                        src={images["PhotoProfile.jpeg"]}
                        alt="Carolina"
                    />
                </FadeInSection>

            </AboutContent>
        </AboutContainer>
    );
}

export default AboutMe;